import { render, staticRenderFns } from "./MiniStatistic.vue?vue&type=template&id=33d45d62&scoped=true&"
import script from "./MiniStatistic.vue?vue&type=script&lang=js&"
export * from "./MiniStatistic.vue?vue&type=script&lang=js&"
import style0 from "./MiniStatistic.vue?vue&type=style&index=0&id=33d45d62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d45d62",
  null
  
)

component.options.__file = "MiniStatistic.vue"
export default component.exports